export default "/images/vendor/flag-icon-css/flags/1x1/ph.svg?374bb0d60bc777e60d0fd5350e9a03cc";